<template>
	<div
		v-if="resource.aitsl.length"
		class="aitsls"
	>
		<div class="aitsl">
			<div class="aitsl-header">
				<h4>{{ title }}<br />Standards</h4>
				<img src="@/images/aitsl.svg?inline" />
			</div>
			<div class="aitsl-body">
				<ol>
					<li v-html="wrapDecimals(aitsl.first)" />
					<li class="line" />
					<li
						v-for="t in aitsl.rest"
						:key="t"
						v-html="wrapDecimals(t)"
					/>
				</ol>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Resource } from '@/interfaces/resourceInterface';
import { resourceAudienceKeys } from '@/interfaces/resourceFilterInterface';

export default defineComponent({
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
	computed: {
		title() {
			return this.resource.audience === resourceAudienceKeys.Leadership ? 'Principal' : 'Teacher';
		},
		aitsl() {
			return {
				first: this.resource.aitsl[0],
				rest: this.resource.aitsl.slice(1),
			};
		},
	},
	methods: {
		wrapDecimals(str: string): string {
			// todo
			// probably better to do this using regex
			const [first, ...r] = str.split(' ');
			const rest = r.join(' ');
			return `<span class="first">${first}</span><span class="rest">${rest}</span>`;
		},
	},
});
</script>

<style scoped lang="scss">
.aitsl {
	margin: 30px 0;
	background-color: #007377;
	-webkit-column-break-inside: avoid;
	break-inside: avoid;
	page-break-inside: avoid;

	.aitsl-header {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		background-color: #003332;
		padding: 30px 20px 15px 60px;
		min-height: 70px;

		h4 {
			margin-top: 0;
			margin-bottom: -4px;
			color: rgb(var(--rs-color-aitsl-green));
			font-size: 1.8rem;
			line-height: 1.05;
			font-family: var(--rs-typography-font-body);
			letter-spacing: 3px;
			text-transform: uppercase;
		}

		img {
			max-width: 60px;
		}
	}

	.aitsl-body {
		padding: 30px 20px 30px 20px;
		color: white;

		ol {
			margin: 0;
			list-style: none;

			li {
				display: flex;
				margin-bottom: 10px;
				font-weight: 600;
				font-size: 1.6rem;
				line-height: 1.2;

				&:deep() {
					.first {
						padding-right: 10px;
						width: 40px;
						color: rgb(var(--rs-color-aitsl-green));
						text-align: right;
					}

					.rest {
						flex: 1;
					}
				}

				&:first-child {
					font-size: 1.8rem;
				}

				&.line {
					margin: 15px 0 15px 40px;
					border-bottom: 1px solid rgb(var(--rs-color-aitsl-green));
					height: 0;
				}
			}
		}
	}
}

@media only print {
	.aitsl {
		.aitsl-header {
			padding: 20px 20px 15px 40px;
			min-height: 50px;

			h4 {
				letter-spacing: 1px;
			}

			img {
				max-width: 50px;
			}
		}

		.aitsl-body {
			padding: 20px 20px 20px 10px;

			ol {
				li {
					display: flex;
					margin-bottom: 6px;

					&:deep() {
						.first {
							width: 30px;
						}
					}

					&.line {
						margin: 10px 0 10px 30px;
					}
				}
			}
		}
	}
}
</style>
